export const blockIconsPrivacyandsecurityVpnLockNew = (
	<span className='material-symbols-outlined'>vpn_lock</span>
);
